module.exports = __webpack_public_path__ + "static/media/NoAccess_PowerBI.166d8961.png";